"use client";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { useGetLoggedInUser } from "@/hooks/use-get-logged-in-user";
import { useSidebar } from "@/stores/sidebar.atoms";
import Link from "next/link";

export function NavigationMobile() {
    const { user: userProfile } = useGetLoggedInUser();

    const [, setSidebar] = useSidebar();

    return (
        <div className="flex justify-end">
            {userProfile === null && (
                <Button
                    size="sm"
                    onClick={() => {
                        setSidebar({ open: true, type: "signup" });
                    }}
                >
                    Sign Up
                </Button>
            )}
            {userProfile === undefined && (
                <div className="flex size-12 items-center justify-center rounded-lg border border-border border-solid">
                    <Skeleton className="size-8 rounded-full" />
                </div>
            )}
            {userProfile != null && (
                <Button asChild size="sm">
                    <Link href="/dashboard">Go to Dashboard</Link>
                </Button>
            )}
        </div>
    );
}
